import React, { useState, useRef, useEffect } from 'react'
import { Box, IconButton, Modal, Tooltip } from '@common/components'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PauseIcon from '@mui/icons-material/Pause'
import { CloseIcon } from '@common/icons'

type TutorialVideoModalProps = {
  open: boolean
  onClose: () => void
}
const TutorialVideoModal = (props: TutorialVideoModalProps) => {
  const { open, onClose } = props
  const [isPlaying, setIsPlaying] = useState(true)
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (open) {
      setIsPlaying(true)
    }
  }, [open])

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause()
      } else {
        videoRef.current.play()
      }
      setIsPlaying(!isPlaying)
    }
  }
  return (
    <Modal
      open={open}
      showCloseBtn={false}
      onClose={onClose}
      paperProps={{
        sx: {
          borderRadius: '10px',
          // p: 3,
          width: '720px',
          maxWidth: '90%',
          aspectRatio: '16/9',
          textAlign: 'center',
          position: 'relative',
        },
      }}
    >
      <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
        <Tooltip title='Close'>
          <IconButton
            disableRipple
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              fontSize: 'small',
              zIndex: 10,
            }}
            onClick={onClose}
          >
            <CloseIcon sx={{ fontSize: 26, color: 'black' }} />
          </IconButton>
        </Tooltip>
        <video
          ref={videoRef}
          src='/mentor_tutorial_recording.mp4'
          autoPlay
          loop
          style={{ width: '100%', height: '100%' }}
        />
        <Box
          onClick={handlePlayPause}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            background: 'rgba(0, 0, 0, 0.2)',
            opacity: 0,
            transition: 'opacity 0.2s',
            ':hover': {
              opacity: 1,
            },
          }}
        >
          {isPlaying ? (
            <PauseIcon sx={{ fontSize: 60, color: 'white' }} />
          ) : (
            <PlayArrowIcon sx={{ fontSize: 60, color: 'white' }} />
          )}
        </Box>
      </Box>
    </Modal>
  )
}

export default TutorialVideoModal
